import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './pages/Home';
import AccesoAutorizado from './pages/AccesoAutorizado';
import FormularDenuncia from './pages/FormularlDenuncia';
import RecordarContrasena from './pages/RecordarContrasena';
import RecordarNotification from './pages/RecordarNotification';
import ConsultarDenuncia from './pages/ConsultarDenuncia';
import ListadoDenuncia from './pages/ListadoDenuncia';
import BackOffice from './pages/BackOffice';
import DownloadCookiesPolicy from './components/DownloadCookiesPolicy';

import { SessionBarProvider } from './context/sessionBar.context';
import { LoadingProvider } from './context/loading.context';

import { ROUTES } from './constants/routes.constants';

export default function Routes() {
  return (
    <Switch>
      <Route path={ROUTES.HOME} exact component={Home} />
      <Route path={ROUTES.DOWNLOAD_COOKIES} exact component={DownloadCookiesPolicy} />
      <Route path={ROUTES.ACCESO_AUTORIZADO} exact component={AccesoAutorizado} />
      <Route path={ROUTES.FORMULAR_DENUNCIA} exact component={FormularDenuncia} />
      <Route path={ROUTES.RECORDAR_CONTRASENA} exact component={RecordarContrasena} />
      <Route path={ROUTES.RECORDAR_NOTIFICACION} exact component={RecordarNotification} />
      <SessionBarProvider>
        <LoadingProvider>
          <Route path={ROUTES.BACK_OFFICE} exact component={BackOffice} />
          <Route path={ROUTES.CONSULTAR_DENUNCIA} exact component={ConsultarDenuncia} />
          <Route
            path={`${ROUTES.CONSULTAR_DENUNCIA}/:id`}
            render={({
              match: {
                params: { id },
              },
            }) => <ConsultarDenuncia idDenuncia={id} />}
          />
          <Route path={ROUTES.LISTADO_DENUNCIA} exact component={ListadoDenuncia} />
        </LoadingProvider>
      </SessionBarProvider>
    </Switch>
  );
}
